import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'fx-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  providers: [],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {}
